import { Component, Input, OnInit } from '@angular/core';
import { DashboardResponse } from '../../models/report.model';

@Component({
    selector: 'app-custom-dashboard',
    templateUrl: './custom-dashboard.component.html',
    styleUrl: './custom-dashboard.component.scss',
})
export class CustomDashboardComponent implements OnInit {
    kpiSections: any[] = [];
    equipmentStatusData: any[] = [];
    jointStatusData: any[] = [];
    defaultImageSrc = '../../../../../../assets/media/logos/Jazan-logo.png';

    @Input() dashboardData: any;
    ngOnInit(): void {}
    LoadCustomDashboard() {}
    formatExactValue = (e: any) => {
        return e.value.toString();
    };
}
